import type { Cart, CartProgram, LanguageIsoCode, Program } from '@/graphql/graphql';
import { GET_CURRENT_CART, UPDATE_CART } from '@/graphql/queries/cart.graphql';
import { apolloClient } from './apollo-client';

export async function getCurrentCart() {
    const response = await apolloClient.query({
        query: GET_CURRENT_CART,
    });

    return response.data.getCurrentCart;
}

export async function addToCart(cart: Cart, program: Program, audio: LanguageIsoCode) {
    const programs = cart.programs ?? [];

    const items: Record<string, string>[] = programs.map((cartProgram: CartProgram) => {
        const item: Record<string, string> = {};
        item[cartProgram.language.toLowerCase()] = cartProgram.program.identifier.id;
        return item;
    });

    const item: Record<string, string> = {};
    item[audio.toLowerCase()] = program.identifier.id;
    items.push(item);
    const response = await apolloClient.mutate({
        mutation: UPDATE_CART,
        variables: {
            id: cart.identifier.id,
            programs: items,
        },
    });

    return response.data;
}

export async function updateCart(cart: Cart) {
    const programs = cart.programs ?? [];

    const items: Record<string, string>[] = programs.map((cartProgram: CartProgram) => {
        const item: Record<string, string> = {};
        item[cartProgram.language.toLowerCase()] = cartProgram.program.identifier.id;
        return item;
    });

    const response = await apolloClient.mutate({
        mutation: UPDATE_CART,
        variables: {
            id: cart.identifier.id,
            programs: items,
        },
    });

    return response.data?.updateCart;
}
